import React from 'react'
import decodeToken from './decodeToken'
import { Navigate, Redirect, Route } from 'react-router-dom'

const PrivateRoute = ({ children }) => {
    let token = localStorage.getItem('token'); 
    return token ? children : <Navigate to="/" />;
  };

export default PrivateRoute